<template>
<div>
<span class="background" @click="closePopup"></span>
  <div class="popup-wrap">
    <article>
      <a class="exit" @click="closePopup">
        <span></span>
        <span></span>
      </a>
      <div class="content">
        <slot></slot>
      </div>
    </article>
  </div>
</div>
</template>

<script>
    export default {
        data () {
            return {
                buttonCancel: true
            }
        },
        methods: {
            closePopup () {
                document.body.style.overflow = "auto";
                this.$emit('close')
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../sass/core/variables.scss";

.background {
    position: fixed;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
}

html {
    overflow: hidden !important;
}


.popup-wrap {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    width: 100%;
    height: 100%;

    overflow-x: hidden;
    overflow-y: auto;

    article {
        position: absolute;
        top: 10%;
        left: 0;
        right: 0;

        width: 90%;
        max-width: 570px;
        margin: auto;
        margin-bottom: 20px;
        padding: 20px;
        //transform: translate(-50%, -50%);

        text-align: center;

        box-shadow: 0 3px 14px rgba(0, 0, 0, 0.2);
        border-radius: 2px;
        background-color: white;

        @media (max-width: $medium) {
            position: relative;
            top: auto;
            left: auto;
            margin: 20px auto;
            transform: translate(0,0);
        }

        @media (min-width: $medium) {
            padding: 60px 20px 40px;
        }

        .exit {
            position: absolute;
            top: 31px;
            right: 30px;

            width: 40px;
            height: 40px;

            cursor: pointer;

            @media (max-width: $medium) {
                top: 11px;
                right: 10px;
                width: 20px;
                height: 20px;
            }

            span {
                position: absolute;
                top: 18px;
                left: 7px;

                display: inline-block;
                width: 26px;
                height: 2px;

                background: #EC0A28;
                transform: rotate(45deg);

                @media (max-width: $medium) {
                    width: 18px;
                    top: 4px;
                    right: 5px;
                }
            }
            span:nth-of-type(2) {
                transform: rotate(-45deg);
            }
        }

        .content {
            display: inline-block;
            vertical-align: top;
            width: 100%;
        }
    }
}

.history {
    article {
        max-width: 968px;
        padding: 40px;

        border-top: 5px solid #ec0a28;

        @media (max-width: $medium) {
            width: 90%;
        }

        img {
            width: 40.9%;
            margin-right: 60px;

            @media (max-width: $medium) { width: 100%; }
        }

        .description {
            width: 45.5%;
            text-align: left;

            @media (max-width: $medium) { margin-top: 30px; width: 100%; }

            h4 {
                margin-bottom: 30px;
                font-size: 40px;
                font-weight: 600;
                line-height: 45px;
            }

            p { margin-bottom: 25px; }

            &.people {
                display: flex;
                align-content: stretch;
                flex-direction: column;

                .top {
                    h4 {
                        margin-bottom: 15px;
                    }

                    .job-title {
                        margin-bottom: 30px;
                    }
                }
                .bottom {
                    margin-top: 38px;

                    h5 {
                        margin-bottom: 16px;
                        font-size: 24px;
                        font-weight: 500;
                        line-height: 28px;
                    }

                    a {
                        display: block;

                        font-size: 18px;
                        font-weight: 300;
                        line-height: 24px;
                        color: #ec0a28;

                        &.email { margin-bottom: 10px; }
                    }
                }

            }

            .contact {
                padding: 18px 48px;
                font-size: 18px;
                font-weight: 700;
                letter-spacing: 0.5px;
                line-height: 24px;
                text-transform: uppercase;
                color: #EC0A28;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                border: 2px solid #EC0A28;
                margin: 40px 0 20px 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Modal.vue